import { Pipe, PipeTransform } from '@angular/core';
import { StringUtilities } from '../misc/string-utilities';

@Pipe({
  name: 'shortDescription'
})
export class ShortDescriptionPipe implements PipeTransform {

  transform(value: string, args = 200): string {
      return StringUtilities.shorten(value, args, '...', true);
  }

}
